import { Photo } from '@material-ui/icons'
import Fire_base from '../Config/Fire_base'

export default async function GetPhotoUrl(ref){
    
    let getPhotourl=''

    await Fire_base.storage().ref(ref).getDownloadURL().then(photoUrl=>{
        getPhotourl=photoUrl
    })
    return getPhotourl
} 